<div  class="mon">
  <div *ngFor="let m of months; let i=index;" class="mthlist" (click)="changeMonth(i)" [class.selected]="i==selectedMonth" [class.today]="i==currentMonth" [class]="datepicker_serv.getClassName(field.arrowClassName)" >{{m}}</div>
</div>
